<template>
	<v-container fluid >
		<div>
			<Lightbox
			:visible="imageGalleryShow"
			:imgs="imageList"
			:index="index"
			@hide="closeImage"
			></Lightbox>
		</div>
		<v-layout row wrap v-if="results == false">
			<v-flex sm8 md4 xs12 offset-sm2 offset-md4>
				<v-card class="pa-4">
					<v-card-text class="grey--text">
						<v-flex xs12>
							{{$t('labels.noResults')}}
						</v-flex>
						<v-layout text-xs-right>
						<v-flex xs12>
							<v-btn @click="back" color="grey lighten-1">{{$t('buttons.back')}}
							</v-btn>
						</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout row wrap v-if="results == true">
			<v-flex xs8 offset-xs2>
				<v-card class="pa-4">
					<v-card-text class="grey--text">
						<v-layout row wrap>
							<v-flex xs3>
								{{$t('labels.results')}} <b>{{object.id}}</b><hr>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs5 pt-2 pb-5>
								{{$t('labels.category')}}: <b>{{object.category}}</b><br>
								{{$t('labels.objectID')}}: <b>{{object.id}}</b><br>
								{{$t('labels.county')}}: <b>{{object.county}}</b><br>
								{{$t('labels.city')}}: <b>{{object.city}}</b><br>
								{{$t('labels.location')}}: <b>{{object.location}}</b><br>
							</v-flex>
							<v-flex xs7 text-xs-right>
								<v-btn @click="back" color="grey lighten-1">{{$t('buttons.back')}}</v-btn>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs12>
								<div class="files-container">
									<v-layout row wrap>
										<v-flex xs12>
											<div v-if="object.photos <= 0" style="text-align:center; line-height:60px;">
												<span>{{ $t('labels.noFilesUploaded') }}</span>
											</div>
											<div v-for="(item, key) in object.photos" :key="key" class="file-tile">
												<div class="tile-image">
													<v-img :src="item.link"/>
												</div>
												<div class="tile-text">
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<span
															v-bind="attrs"
															v-on="on"
															>{{ item.name }}</span>
														</template>
														<span>{{ item.name }}</span>
													</v-tooltip>
												</div>
											</div>
										</v-flex>
									</v-layout>
									<v-layout row wrap v-if="object.photos.length >= 1">
										<v-flex xs12 text-xs-right>
											<v-tooltip bottom>
												<v-btn @click="downloadImages" icon slot="activator">
													<v-icon>fa-cloud-download-alt</v-icon>
												</v-btn>
												<span>{{ $t('tooltips.downloadAll') }}</span>
											</v-tooltip>
										</v-flex>
									</v-layout>
								</div>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs8 v-for="(item, key) in object.languages" :key="key" pt-4>
								<v-layout row wrap>
									<v-flex xs9 pr-4>
										<InputField :label="item['label'] + ' ' + $t('labels.videoUrl')"
										v-model="object.videos[key]"
										:readonly="true"></InputField>
									</v-flex>
								</v-layout>
								<v-layout row wrap>
									<v-flex xs8 v-if="videoLinks[key] != null">
										<template>
											<div id="app">
												<LazyYoutube
													ref="youtubeLazyVideo"
													:src="videoLinks[key]"
													max-width="720px"
													aspect-ratio="16:9"
													thumbnail-quality="standard"
												/>
											</div>
										</template>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import InputField from "./trinkets/InputField";
import UploadMultiple from "./trinkets/UploadMultiple";
import Dropdown from "./trinkets/Dropdown";
import { LazyYoutube } from "vue-lazytube";
import Lightbox from 'vue-easy-lightbox';

	export default {
		name: 'App',
		components: {InputField, UploadMultiple, Dropdown, LazyYoutube, Lightbox},
		data() {
			return {
				results: null,
				object: {
					category: '',
					id: '',
					county: null,
					city: null,
					location: '',
					photos: [],
					videos: [],
					languages: []
				},
				videoLinks: [],
				imageGalleryShow: false,
				index: 0,
				imageList: [],
			}
		},
		watch: {
			"object.videos":{
				handler: function() {
					this.videoLinks = [];
					for (const element of this.object.videos){
						if(element != null){
							let regExp = /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;
							let match = element.match(regExp);
							if(match){
								this.videoLinks.push(element);
							}
							else{
								this.videoLinks.push(null);
							}
						}
						else{
							this.videoLinks.push(null);
						}
					}
				}
			}
		},
		computed: {

		},
		methods: {
			empty(){

			},
			back(){
				this.$router.push('/dashboard/');
			},
			downloadImages(){
				let vm = this;
				let data = {
					photos: this.object.photos,
					opportunity_id: this.object.id
				}
				this.$APICall('post', 'download-opportunity', data, (data, success) => {
					window.open(data.link);
				});
			},
			openImage(key){
				this.imageGalleryShow = true;
				this.index = key;
			},
			closeImage(){
				this.imageGalleryShow = false;
			},
			listImages(){
				for (const element of this.object.photos){
					this.imageList.push(element.link);
				}
			}
		},
		mounted() {
			let vm = this;
			this.$APICall('get', 'opportunities/' + this.$route.params.id, {}, (data, success) => {
				if (success) {
					if(data != '404'){
						let usableData = JSON.parse(JSON.stringify(data));
						vm.results = true;
						vm.object = usableData;
						if(vm.object.id != null && vm.object.id != undefined){
							vm.object.id = vm.object.id.toUpperCase();
						}
						vm.listImages();
					}
					else{
						vm.results = false;
					}
				}
				else{
					vm.results = false;
				}
			});
		}
	}
</script>

<style scoped>

.files-container{
	margin: 5px;
	padding: 5px;
	border: 1px solid rgb(206, 206, 206);
	border-radius: 3px;
	min-height: 250px;
	max-height: 420px;
	overflow-x: auto;
}

.file-tile{
	margin: 2px;
	padding: 2px;
	height: 180px;
	width: 120px;
	text-align: center;
	display: inline-block;
	overflow:hidden;
	word-wrap: break-word;
}

.file-tile:hover{
	background-color: rgb(240, 240, 240);
}

.tile-image{
	margin: 2px;
	padding: 2px;
	height: 100px;
	width: 116px;
	overflow:hidden;
}

.tile-image:hover{
	cursor: pointer;
}

.tile-text{
	margin: 2px;
	padding: 2px;
	height: 30px;
	width: 116px;
	font-size: 10px;
	overflow:hidden;
}
</style>
